import { clientTime } from "../../utilities/index";
import { dateFormat } from "../../utilities/parseHelper";
import { Http } from "./http";
import Axios, { AxiosResponse } from "axios";

/**Запросы к методам регистрации в есиа */
export class EsiaAuthApi {
  /**
   * Получение ссылки для редиректа
   * @returns> ссылка на есиа
   * */
  public static async getRedirectLink(): Promise<string> {
    // Получаем токен
    const respData = await Http.get(`WebClient/GetEsiaRedirectLink`);

    return respData ? respData.data?.redirect_url : '';
  }

}
